import { IconArrowAutofitContent, IconArrowsSort, IconBaselineDensityLarge, IconBaselineDensityMedium, IconBaselineDensitySmall, IconBoxMultiple, IconChevronDown, IconChevronLeft, IconChevronLeftPipe, IconChevronRight, IconChevronRightPipe, IconChevronsDown, IconCircleX, IconClearAll, IconColumns, IconDeviceFloppy, IconDots, IconDotsVertical, IconEdit, IconEyeOff, IconFilter, IconFilterCog, IconFilterOff, IconGripHorizontal, IconMaximize, IconMinimize, IconPinned, IconPinnedOff, IconSearch, IconSearchOff, IconSortAscending, IconSortDescending, IconX, } from '@tabler/icons-react';
export const MRT_Default_Icons = {
    IconArrowAutofitContent,
    IconArrowsSort,
    IconBaselineDensityLarge,
    IconBaselineDensityMedium,
    IconBaselineDensitySmall,
    IconBoxMultiple,
    IconChevronDown,
    IconChevronLeft,
    IconChevronLeftPipe,
    IconChevronRight,
    IconChevronRightPipe,
    IconChevronsDown,
    IconCircleX,
    IconClearAll,
    IconColumns,
    IconDeviceFloppy,
    IconDots,
    IconDotsVertical,
    IconEdit,
    IconEyeOff,
    IconFilter,
    IconFilterCog,
    IconFilterOff,
    IconGripHorizontal,
    IconMaximize,
    IconMinimize,
    IconPinned,
    IconPinnedOff,
    IconSearch,
    IconSearchOff,
    IconSortAscending,
    IconSortDescending,
    IconX,
};
//# sourceMappingURL=icons.js.map